import classNames from 'classnames'
import React from 'react'

interface FormGroupProps {
  label?: string
  children?: React.ReactNode
  tools?: React.ReactNode
  flag?: React.ReactNode
  block?: boolean
  required?: boolean
  className?: string
  errorMessage?: string
}

export const FormGroup: React.FC<FormGroupProps> = ({
  label,
  children,
  tools,
  flag,
  required,
  className,
  errorMessage
}) => {
  return (
    <div className={classNames(className)}>
      {label || flag || tools ? (
        <div className={classNames('mb-3 flex items-center', { 'text-red-600': errorMessage })}>
          {label && (
            <label className="block text-sm font-medium">
              {required ? '*' : ''}
              {label}
            </label>
          )}
          {flag && <div className="ml-2">{flag}</div>}
          {tools && <div className="ml-auto">{tools}</div>}
        </div>
      ) : null}
      {children}

      {errorMessage && <div className="mt-1 text-xs text-danger">{errorMessage}</div>}
    </div>
  )
}
